module.exports.excerptSeparator = '<!-- endexcerpt -->';